import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { Switch } from '@components/core-ui/form-elements/Switch';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useModalContext } from '@providers/ModalProvider';
import { FeatureFlagsService } from 'app/API';
import React, { useState } from 'react';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const CreateNewAttorneyFeatureFlag = ({ onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { closeModal } = useModalContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [flag, setFlag] = useState({
    name: '',
    value: false,
  });

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await call(FeatureFlagsService.createForAttorneyView({ requestBody: { name: flag.name, value: flag.value } }));
    setIsSubmitting(false);
    closeModal();
    onSuccess();
  };

  return (
    <ModalWrapper width="370px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Create new Feature Flag</ModalTitle>
      <Content>
        <div className="input-wrapper">
          <div className="label">Name</div>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFlag({ ...flag, name: e.target.value })}
            label="Name"
            value={flag.name}
          />
        </div>

        <div className="input-wrapper">
          <div className="label">Value</div>
          <Switch className="switch" checked={flag.value} onChange={() => setFlag({ ...flag, value: !flag.value })} />
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
